import React, {
  useCallback,
  useMemo,
} from 'react';
import {
  useNotify,
  useSidePanel,
} from 'core/hooks';
import NotesIcon from 'core/icons/notes';
import PrinterIcon from 'core/icons/printer';
import {
  Button,
} from 'pages/Dashboard/components/Button';
import {
  usePreparePaperClaims,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
  DropdownMenuItem,
} from 'core/components/DropdownMenu';
import SplitActionButton from 'core/components/SplitActionButton';
import ToolTip from 'core/components/Tooltip';

export default function BulkClaimsButton() {
  const { openPanel } = useSidePanel();
  const { mutateAsync: schedulePrint, isPending: isLoading } = usePreparePaperClaims();
  const notify = useNotify();

  const onPrint = useCallback(async (includeFormBackground: boolean) => {
    await schedulePrint({ includeFormBackground });
    notify({
      message: 'Bulk paper claims are being prepared',
      variant: 'success',
    });
  }, [schedulePrint, notify]);

  const menuItems: DropdownMenuItem[] = useMemo(() => ([
    {
      id: 'full-cms',
      label: 'Full CMS-1500',
      onSelect: () => { onPrint(true); },
    },
    {
      id: 'preprinted-cms',
      label: 'Pre-printed CMS-1500',
      onSelect: () => { onPrint(false); },
    },
  ]), [onPrint]);

  return (
    <div className="flex gap-2">
      <SplitActionButton
        label={(
          <span className="hidden lg:inline">
            {isLoading ? 'Sending request...' : 'Bulk Claims Print'}
          </span>
        )}
        onPrimaryClick={() => { onPrint(true); }}
        items={menuItems}
        disabled={isLoading}
        startIcon={<PrinterIcon className="!w-4 !h-4" />}
        showArrow={false}
        placement="bottom-end"
        paperClassName="!min-w-[11rem]"
      />
      <ToolTip title="View bulk paper claims">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            openPanel('bulkClaims', {});
          }}
          className="!px-2.5"
        >
          <NotesIcon className="!w-4 !h-4 !text-white" />
        </Button>
      </ToolTip>
    </div>
  );
}
